import React from "react";
import { Input } from "@/components/ui/input";
import { Checkbox } from "@/components/ui/checkbox";
import { formatKM, parseDecimal, toInputComma } from "@/lib/format";

export default function PorijekloItems({ items, originDefault, onChange }) {
  const set = (idx, patch) => onChange(items.map((it, i) => (i === idx ? { ...it, ...patch } : it)));
  return (
    <div className="rounded-xl border bg-card overflow-x-auto" data-testid="porijeklo-items">
      <table className="w-full text-sm">
        <thead className="bg-secondary/60 text-xs uppercase text-muted-foreground">
          <tr>
            <th className="p-2 text-left">RB</th>
            <th className="p-2 text-left">Porijeklo?</th>
            <th className="p-2 text-left min-w-[200px]">Vrsta robe</th>
            <th className="p-2 text-left">Tarifni broj</th>
            <th className="p-2 text-left">Porijeklo</th>
            <th className="p-2 text-right">Vrijednost (BAM)</th>
          </tr>
        </thead>
        <tbody>
          {items.map((it, idx) => (
            <tr key={idx} className={`border-t ${it.has_origin ? "bg-red-50 dark:bg-red-950/30" : ""}`} data-testid={`porijeklo-item-${idx}`}>
              <td className={`p-2 font-bold ${it.has_origin ? "text-red-600" : ""}`}>{it.rb}</td>
              <td className="p-2">
                <Checkbox checked={!!it.has_origin} onCheckedChange={(v) => set(idx, { has_origin: !!v })} data-testid={`porijeklo-item-origin-toggle-${idx}`} />
              </td>
              <td className="p-2"><Input value={it.name || ""} onChange={(e) => set(idx, { name: e.target.value })} className="h-8" /></td>
              <td className="p-2"><Input value={it.tariff ?? "/"} onChange={(e) => set(idx, { tariff: e.target.value })} className="h-8 w-28" data-testid={`porijeklo-item-tariff-${idx}`} /></td>
              <td className="p-2">
                {it.has_origin ? (
                  <Input value={it.origin ?? ""} placeholder={originDefault} onChange={(e) => set(idx, { origin: e.target.value })} className="h-8 w-20" data-testid={`porijeklo-item-country-${idx}`} />
                ) : <span className="text-muted-foreground">/</span>}
              </td>
              <td className="p-2 text-right">
                <Input
                  value={it._raw ?? toInputComma(it.value)}
                  inputMode="decimal"
                  onChange={(e) => set(idx, { _raw: e.target.value, value: parseDecimal(e.target.value) })}
                  className="h-8 w-28 ml-auto text-right tabular-nums"
                  title={formatKM(it.value)}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
